import React from "react";
import { Link } from "react-router-dom";
import {
  FaCalendarAlt,
  FaUser,
  FaClock,
  FaChevronLeft,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
} from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DetailBlog6 = () => {
  const blogPost = {
    id: 5,
    title: "Avantages en nature : quel impact sur votre salaire net ?",
    excerpt: "La fiche de paie est un document central dans la relation entre employeur et salarié, mais sa structure peut parfois sembler complexe. Comment passe-t-on du salaire brut convenu au montant net effectivement perçu ? Découvrez le processus complet de calcul basé sur le Code Général des Impôts 2025.",
    content: `
      <div class="introduction-box p-4 mb-4" style="background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%); border-radius: 12px; border-left: 5px solid #dc3545;">
        <p class="lead mb-0">La fiche de paie est un document central dans la relation entre employeur et salarié, mais sa structure peut parfois sembler complexe. Comment passe-t-on du salaire brut convenu au montant net effectivement perçu ? Quelles sont les retenues obligatoires ?</p>
      </div>
      
      <p>Par cet article, nous vous proposons de décrypter ce processus <strong>étape par étape</strong>, en nous basant sur les dispositions du <strong>Code Général des Impôts 2025</strong> de la République du Bénin. Ce guide vous aidera, que vous soyez dirigeant d'entreprise ou salarié, à maîtriser les concepts de salaire brut, d'impôts sur salaire et de salaire net.</p>
      
      <div class="key-highlight-box p-4 mb-4" style="background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%); border-radius: 12px; border-left: 5px solid #ffc107;">
        <h4 style="color: #856404; margin-bottom: 15px;">📌 Formule Clé</h4>
        <div class="formula-box p-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 8px; font-family: monospace; text-align: center; font-size: 1.2rem; font-weight: bold;">
          SALAIRE NET = SALAIRE BRUT IMPOSABLE - ITS - COTISATIONS SOCIALES
        </div>
      </div>
      
      <h2 class="section-title" style="color: #dc3545; border-bottom: 3px solid #dc3545; padding-bottom: 10px; margin-top: 3rem;">1. LA DÉTERMINATION DU SALAIRE BRUT IMPOSABLE</h2>
      
      <p>Le point de départ de tout calcul est le <strong>salaire brut imposable</strong>. Il ne se limite pas au salaire de base. Selon l'<strong>article 122 du CGI</strong>, il inclut l'ensemble des rémunérations et avantages perçus par le salarié.</p>
      
      <div class="formula-main p-4 mb-4" style="background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c8 100%); border-radius: 12px; border-left: 5px solid #28a745;">
        <div class="text-center mb-3">
          <h4 style="color: #155724; margin-bottom: 20px;">💰 Composition du Salaire Brut Imposable</h4>
          <div class="formula-box p-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 8px; font-family: monospace; font-size: 1.1rem; font-weight: bold;">
            SALAIRE BRUT IMPOSABLE = SALAIRE DE BASE + RÉMUNÉRATIONS ACCESSOIRES + AVANTAGES EN NATURE
          </div>
        </div>
      </div>
      
      <h3 style="color: #198754; margin-top: 2rem;">📋 Les Rémunérations Accessoires</h3>
      
      <p>Il s'agit de toutes les sommes versées en argent, en plus du salaire de base :</p>
      
      <div class="remunerations-grid row mb-4">
        <div class="col-md-6 mb-3">
          <div class="remuneration-card p-3" style="background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%); border-radius: 10px; border-left: 4px solid #2196f3;">
            <h5 style="color: #0d47a1;">💵 Primes</h5>
            <ul class="mb-0" style="font-size: 0.95rem;">
              <li>Prime de rendement</li>
              <li>Prime d'ancienneté</li>
              <li>Prime de responsabilité</li>
            </ul>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="remuneration-card p-3" style="background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%); border-radius: 10px; border-left: 4px solid #9c27b0;">
            <h5 style="color: #4a148c;">🎁 Gratifications</h5>
            <ul class="mb-0" style="font-size: 0.95rem;">
              <li>13ème mois</li>
              <li>Primes exceptionnelles</li>
              <li>Bonus de performance</li>
            </ul>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="remuneration-card p-3" style="background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%); border-radius: 10px; border-left: 4px solid #ffc107;">
            <h5 style="color: #856404;">⏰ Heures supplémentaires</h5>
            <ul class="mb-0" style="font-size: 0.95rem;">
              <li>Heures de nuit</li>
              <li>Heures du week-end</li>
              <li>Jours fériés</li>
            </ul>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="remuneration-card p-3" style="background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%); border-radius: 10px; border-left: 4px solid #dc3545;">
            <h5 style="color: #c62828;">🚗 Indemnités diverses</h5>
            <ul class="mb-0" style="font-size: 0.95rem;">
              <li>Indemnité de transport</li>
              <li>Indemnité de fonction</li>
              <li>Indemnité de déplacement</li>
            </ul>
          </div>
        </div>
      </div>
      
      <h3 style="color: #198754; margin-top: 2.5rem;">🏠 Les Avantages en Nature : Un Élément Clé du Salaire</h3>
      
      <div class="important-box p-4 mb-4" style="background: linear-gradient(135deg, #d1ecf1 0%, #bee5eb 100%); border-radius: 12px; border-left: 5px solid #17a2b8;">
        <p class="mb-2"><strong>L'article 123 du CGI est très clair :</strong></p>
        <p class="mb-0">Les biens et services mis à la disposition du salarié par l'employeur constituent un <strong>complément de salaire imposable</strong>. Ils sont évalués de deux manières :</p>
      </div>
      
      <div class="evaluation-methods row mb-4">
        <div class="col-md-6 mb-3">
          <div class="method-card p-4 h-100" style="background-color: #fff; border-radius: 12px; border: 2px solid #28a745; box-shadow: 0 4px 15px rgba(40, 167, 69, 0.1);">
            <h5 style="color: #28a745; margin-bottom: 15px;">✅ À leur Valeur Réelle</h5>
            <ul class="mb-0">
              <li>Frais de scolarité des enfants</li>
              <li>Frais médicaux (hors exceptions)</li>
              <li>Billets d'avion (hors première arrivée et départ définitif)</li>
            </ul>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="method-card p-4 h-100" style="background-color: #fff; border-radius: 12px; border: 2px solid #dc3545; box-shadow: 0 4px 15px rgba(220, 53, 69, 0.1);">
            <h5 style="color: #dc3545; margin-bottom: 15px;">📊 De Manière Forfaitaire</h5>
            <p class="mb-0">Pour les avantages les plus courants, le CGI fixe un <strong>barème mensuel précis</strong> (voir tableau ci-dessous)</p>
          </div>
        </div>
      </div>
      
      <h4 style="color: #0c5460; margin-top: 2rem; margin-bottom: 1.5rem;">📋 Tableau d'Évaluation Forfaitaire des Avantages en Nature</h4>
      
      <div class="table-responsive mb-4">
        <table class="table-avantages" style="width: 100%; border-collapse: collapse; background-color: white; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);">
          <thead>
            <tr style="background: linear-gradient(135deg, #dc3545 0%, #198754 100%); color: white;">
              <th style="padding: 15px; text-align: left; font-weight: 600;">Avantage</th>
              <th style="padding: 15px; text-align: center; font-weight: 600;">Dirigeants et Cadres Supérieurs</th>
              <th style="padding: 15px; text-align: center; font-weight: 600;">Employés</th>
            </tr>
          </thead>
          <tbody>
            <tr style="border-bottom: 1px solid #e9ecef;">
              <td style="padding: 12px; font-weight: 500;">🏠 Logement</td>
              <td style="padding: 12px; text-align: center; background-color: #f8f9fa;">15% du salaire de base</td>
              <td style="padding: 12px; text-align: center; background-color: #f8f9fa;">15% du salaire de base</td>
            </tr>
            <tr style="border-bottom: 1px solid #e9ecef;">
              <td style="padding: 12px; font-weight: 500;">👨‍👩‍👧 Domesticité</td>
              <td style="padding: 12px; text-align: center;">15% du salaire de base (sous conditions)</td>
              <td style="padding: 12px; text-align: center;">15% du salaire de base (sous conditions)</td>
            </tr>
            <tr style="border-bottom: 1px solid #e9ecef;">
              <td style="padding: 12px; font-weight: 500;">⚡ Électricité</td>
              <td style="padding: 12px; text-align: center; background-color: #f8f9fa;"><strong>50 000 FCFA</strong></td>
              <td style="padding: 12px; text-align: center; background-color: #f8f9fa;"><strong>20 000 FCFA</strong></td>
            </tr>
            <tr style="border-bottom: 1px solid #e9ecef;">
              <td style="padding: 12px; font-weight: 500;">💧 Eau</td>
              <td style="padding: 12px; text-align: center;"><strong>10 000 FCFA</strong></td>
              <td style="padding: 12px; text-align: center;"><strong>5 000 FCFA</strong></td>
            </tr>
            <tr style="border-bottom: 1px solid #e9ecef;">
              <td style="padding: 12px; font-weight: 500;">📞 Téléphone</td>
              <td style="padding: 12px; text-align: center; background-color: #f8f9fa;"><strong>15 000 FCFA</strong></td>
              <td style="padding: 12px; text-align: center; background-color: #f8f9fa;"><strong>5 000 FCFA</strong></td>
            </tr>
            <tr style="border-bottom: 1px solid #e9ecef;">
              <td style="padding: 12px; font-weight: 500;">🍽️ Nourriture</td>
              <td style="padding: 12px; text-align: center;"><strong>50 000 FCFA</strong></td>
              <td style="padding: 12px; text-align: center;"><strong>30 000 FCFA</strong></td>
            </tr>
            <tr style="border-bottom: 1px solid #e9ecef;">
              <td style="padding: 12px; font-weight: 500;">🚗 Véhicule (4 roues)</td>
              <td style="padding: 12px; text-align: center; background-color: #f8f9fa;"><strong>30 000 FCFA</strong></td>
              <td style="padding: 12px; text-align: center; background-color: #f8f9fa;"><strong>15 000 FCFA</strong></td>
            </tr>
            <tr>
              <td style="padding: 12px; font-weight: 500;">🏍️ Véhicule (2 roues)</td>
              <td style="padding: 12px; text-align: center;"><strong>10 000 FCFA</strong></td>
              <td style="padding: 12px; text-align: center;"><strong>5 000 FCFA</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <h2 class="section-title" style="color: #dc3545; border-bottom: 3px solid #dc3545; padding-bottom: 10px; margin-top: 3rem;">2. LE CALCUL DE L'IMPÔT SUR LES TRAITEMENTS ET SALAIRES (ITS)</h2>
      
      <p>Une fois le salaire brut imposable déterminé, on y applique le <strong>barème progressif de l'Impôt sur les Traitements et Salaires (ITS)</strong>, tel que défini par l'<strong>article 125 du CGI</strong>. C'est la principale retenue fiscale opérée sur le salaire.</p>
      
      <h3 style="color: #198754; margin-top: 2rem; margin-bottom: 1.5rem;">📊 Barème Progressif Mensuel de l'ITS</h3>
      
      <div class="bareme-its mb-4">
        <div class="bareme-item p-3 mb-2" style="background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%); border-radius: 10px; border-left: 5px solid #28a745;">
          <div class="d-flex justify-content-between align-items-center">
            <span style="font-weight: 600;">0 à 60 000 FCFA</span>
            <span style="font-size: 1.2rem; font-weight: bold; color: #28a745;">0%</span>
          </div>
        </div>
        <div class="bareme-item p-3 mb-2" style="background: linear-gradient(135deg, #d1ecf1 0%, #bee5eb 100%); border-radius: 10px; border-left: 5px solid #17a2b8;">
          <div class="d-flex justify-content-between align-items-center">
            <span style="font-weight: 600;">60 001 à 150 000 FCFA</span>
            <span style="font-size: 1.2rem; font-weight: bold; color: #17a2b8;">10%</span>
          </div>
        </div>
        <div class="bareme-item p-3 mb-2" style="background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%); border-radius: 10px; border-left: 5px solid #ffc107;">
          <div class="d-flex justify-content-between align-items-center">
            <span style="font-weight: 600;">150 001 à 250 000 FCFA</span>
            <span style="font-size: 1.2rem; font-weight: bold; color: #856404;">15%</span>
          </div>
        </div>
        <div class="bareme-item p-3 mb-2" style="background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%); border-radius: 10px; border-left: 5px solid #dc3545;">
          <div class="d-flex justify-content-between align-items-center">
            <span style="font-weight: 600;">250 001 à 500 000 FCFA</span>
            <span style="font-size: 1.2rem; font-weight: bold; color: #dc3545;">19%</span>
          </div>
        </div>
        <div class="bareme-item p-3" style="background: linear-gradient(135deg, #e8e8e8 0%, #d0d0d0 100%); border-radius: 10px; border-left: 5px solid #343a40;">
          <div class="d-flex justify-content-between align-items-center">
            <span style="font-weight: 600;">Supérieur à 500 000 FCFA</span>
            <span style="font-size: 1.2rem; font-weight: bold; color: #343a40;">30%</span>
          </div>
        </div>
      </div>
      
      <h3 style="color: #0c5460; margin-top: 2.5rem;">💼 EXEMPLE PRATIQUE DE CALCUL</h3>
      
      <div class="case-study-box p-4 mb-4" style="background: linear-gradient(135deg, #e8f4fd 0%, #d1ecf1 100%); border-radius: 15px; border: 2px solid #17a2b8; box-shadow: 0 6px 20px rgba(23, 162, 184, 0.15);">
        <h5 style="color: #0c5460; margin-bottom: 20px;">👔 Profil : Cadre Supérieur</h5>
        
        <div class="case-data p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
          <h6 style="color: #0c5460;">📋 Données du mois</h6>
          <ul class="mb-0">
            <li><strong>Salaire de base :</strong> 800 000 FCFA</li>
            <li><strong>Indemnité de transport :</strong> 50 000 FCFA</li>
            <li><strong>Avantages en nature :</strong> Logement + Véhicule 4 roues</li>
          </ul>
        </div>
        
        <div class="calculation-section p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
          <h6 style="color: #0c5460;">🧮 ÉTAPE A : Calcul du Salaire Brut Imposable</h6>
          <div class="calculation-steps">
            <p class="mb-2"><strong>1.</strong> Salaire de base + Indemnité : 800 000 + 50 000 = <strong>850 000 FCFA</strong></p>
            <p class="mb-2"><strong>2.</strong> Valeur du logement : 15% de 800 000 = <strong>120 000 FCFA</strong></p>
            <p class="mb-2"><strong>3.</strong> Valeur du véhicule : <strong>30 000 FCFA</strong> (selon le barème)</p>
          </div>
          <div class="result-box p-3 mt-3" style="background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%); border-radius: 8px; text-align: center;">
            <strong style="color: #28a745; font-size: 1.2rem;">SBI = 850 000 + 120 000 + 30 000 = 1 000 000 FCFA</strong>
          </div>
        </div>
        
        <div class="calculation-section p-3 mb-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 10px;">
          <h6 style="color: #0c5460;">💰 ÉTAPE B : Calcul de l'ITS sur le SBI de 1 000 000 FCFA</h6>
          <p class="mb-3"><em>L'impôt est calculé tranche par tranche :</em></p>
          
          <div class="tranches-calculation">
            <div class="tranche-item p-2 mb-2" style="background-color: #d4edda; border-radius: 6px;">
              <div class="d-flex justify-content-between">
                <span>Tranche de 0 à 60 000 :</span>
                <span><strong>60 000 × 0% = 0 FCFA</strong></span>
              </div>
            </div>
            <div class="tranche-item p-2 mb-2" style="background-color: #d1ecf1; border-radius: 6px;">
              <div class="d-flex justify-content-between">
                <span>Tranche de 60 001 à 150 000 (90 000) :</span>
                <span><strong>90 000 × 10% = 9 000 FCFA</strong></span>
              </div>
            </div>
            <div class="tranche-item p-2 mb-2" style="background-color: #fff3cd; border-radius: 6px;">
              <div class="d-flex justify-content-between">
                <span>Tranche de 150 001 à 250 000 (100 000) :</span>
                <span><strong>100 000 × 15% = 15 000 FCFA</strong></span>
              </div>
            </div>
            <div class="tranche-item p-2 mb-2" style="background-color: #f8d7da; border-radius: 6px;">
              <div class="d-flex justify-content-between">
                <span>Tranche de 250 001 à 500 000 (250 000) :</span>
                <span><strong>250 000 × 19% = 47 500 FCFA</strong></span>
              </div>
            </div>
            <div class="tranche-item p-2 mb-3" style="background-color: #e8e8e8; border-radius: 6px;">
              <div class="d-flex justify-content-between">
                <span>Tranche supérieure à 500 000 (500 000) :</span>
                <span><strong>500 000 × 30% = 150 000 FCFA</strong></span>
              </div>
            </div>
          </div>
          
          <div class="result-box p-3 mt-3" style="background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%); border-radius: 8px; text-align: center; border: 2px solid #dc3545;">
            <strong style="color: #dc3545; font-size: 1.3rem;">ITS Total = 0 + 9 000 + 15 000 + 47 500 + 150 000 = 221 500 FCFA</strong>
          </div>
        </div>
      </div>
      
      <h2 class="section-title" style="color: #dc3545; border-bottom: 3px solid #dc3545; padding-bottom: 10px; margin-top: 3rem;">3. LA DÉTERMINATION DU SALAIRE NET À PAYER</h2>
      
      <p>Le salaire net est le montant que le salarié reçoit après déduction des impôts et autres retenues obligatoires.</p>
      
      <div class="formula-net p-4 mb-4" style="background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%); border-radius: 12px; border-left: 5px solid #2196f3;">
        <h5 style="color: #0d47a1; margin-bottom: 15px; text-align: center;">💵 Formule du Salaire Net</h5>
        <div class="formula-box p-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 8px; font-family: monospace; text-align: center; font-size: 1.1rem; font-weight: bold;">
          Salaire Net = Salaire Brut Imposable - ITS - Autres Retenues (cotisations sociales)
        </div>
      </div>
      
      <div class="example-net p-4 mb-4" style="background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c8 100%); border-radius: 12px; border: 2px solid #28a745;">
        <h5 style="color: #155724; margin-bottom: 15px;">📊 Suite de notre exemple</h5>
        <p class="mb-2"><strong>Salaire Net (avant autres retenues) :</strong></p>
        <div class="calculation-box p-3" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 8px;">
          <p class="mb-2">1 000 000 FCFA - 221 500 FCFA = <strong style="color: #28a745; font-size: 1.2rem;">778 500 FCFA</strong></p>
        </div>
        <div class="note-box p-3 mt-3" style="background-color: rgba(255, 243, 205, 0.5); border-radius: 8px; border-left: 3px solid #ffc107;">
          <p class="mb-0"><strong>⚠️ Note importante :</strong> À cela s'ajoutent d'autres retenues comme les <strong>cotisations sociales salariales (CNSS)</strong>, qui viendront également en déduction pour obtenir le net final.</p>
        </div>
      </div>
      
      <h2 class="section-title" style="color: #dc3545; border-bottom: 3px solid #dc3545; padding-bottom: 10px; margin-top: 3rem;">4. LE RÔLE DE L'EMPLOYEUR : Retenue à la Source et VPS</h2>
      
      <div class="employer-obligations p-4 mb-4" style="background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%); border-radius: 12px; border-left: 5px solid #9c27b0;">
        <h5 style="color: #4a148c; margin-bottom: 15px;">📌 Obligations de l'Employeur</h5>
        <p>L'<strong>article 127 du CGI</strong> stipule que l'employeur a l'obligation d'opérer la <strong>retenue à la source de l'ITS</strong> et de la reverser à l'administration fiscale <strong>au plus tard le 10 du mois suivant</strong>.</p>
      </div>
      
      <h3 style="color: #198754; margin-top: 2rem;">💼 Le Versement Patronal sur Salaires (VPS)</h3>
      
      <div class="vps-info row mb-4">
        <div class="col-md-6 mb-3">
          <div class="vps-card p-4 h-100" style="background-color: #fff; border-radius: 12px; border: 2px solid #dc3545; box-shadow: 0 4px 15px rgba(220, 53, 69, 0.1);">
            <h5 style="color: #dc3545; margin-bottom: 15px;">📊 Taux du VPS</h5>
            <ul class="mb-0">
              <li><strong>Taux général :</strong> 4% de la base ITS</li>
              <li><strong>Enseignement privé :</strong> 2% de la base ITS</li>
            </ul>
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="vps-card p-4 h-100" style="background-color: #fff; border-radius: 12px; border: 2px solid #28a745; box-shadow: 0 4px 15px rgba(40, 167, 69, 0.1);">
            <h5 style="color: #28a745; margin-bottom: 15px;">⚠️ Point Important</h5>
            <p class="mb-0">Cette charge est <strong>supportée par l'employeur</strong> et <strong>ne doit pas être déduite du salaire du personnel</strong>.</p>
          </div>
        </div>
      </div>
      
      <div class="warning-box p-4 mb-4" style="background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%); border-radius: 12px; border: 2px solid #ffc107;">
        <h5 style="color: #856404; margin-bottom: 15px;">🚨 Attention</h5>
        <p class="mb-0">Le VPS est calculé sur la <strong>même base que l'ITS</strong> (salaire brut imposable), mais il s'agit d'une charge patronale distincte de l'ITS qui est à la charge du salarié.</p>
      </div>
      
      <div class="schema-recap p-4 mb-4" style="background-color: #f8f9fa; border-radius: 12px;">
        <h4 style="color: #495057; margin-bottom: 20px; text-align: center;">📊 Schéma Récapitulatif</h4>
        
        <div class="flow-diagram">
          <div class="flow-step p-3 mb-3" style="background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c8 100%); border-radius: 10px; text-align: center; border: 2px solid #28a745;">
            <h6 style="color: #155724; margin-bottom: 10px;">1️⃣ SALAIRE DE BASE</h6>
            <p class="mb-0" style="font-size: 0.9rem;">+ Rémunérations accessoires + Avantages en nature</p>
          </div>
          
          <div class="text-center mb-3">
            <span style="font-size: 2rem; color: #6c757d;">⬇️</span>
          </div>
          
          <div class="flow-step p-3 mb-3" style="background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%); border-radius: 10px; text-align: center; border: 2px solid #2196f3;">
            <h6 style="color: #0d47a1; margin-bottom: 10px;">2️⃣ SALAIRE BRUT IMPOSABLE</h6>
            <p class="mb-0" style="font-size: 0.9rem;">Base de calcul de l'ITS</p>
          </div>
          
          <div class="text-center mb-3">
            <span style="font-size: 2rem; color: #6c757d;">⬇️</span>
          </div>
          
          <div class="flow-step p-3 mb-3" style="background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%); border-radius: 10px; text-align: center; border: 2px solid #ffc107;">
            <h6 style="color: #856404; margin-bottom: 10px;">3️⃣ CALCUL DE L'ITS</h6>
            <p class="mb-0" style="font-size: 0.9rem;">Application du barème progressif</p>
          </div>
          
          <div class="text-center mb-3">
            <span style="font-size: 2rem; color: #6c757d;">⬇️</span>
          </div>
          
          <div class="flow-step p-3" style="background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%); border-radius: 10px; text-align: center; border: 2px solid #dc3545;">
            <h6 style="color: #c62828; margin-bottom: 10px;">4️⃣ SALAIRE NET</h6>
            <p class="mb-0" style="font-size: 0.9rem;">SBI - ITS - Cotisations sociales</p>
          </div>
        </div>
      </div>
      
      <div class="conclusion-section p-4 mb-4" style="background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%); border-radius: 15px; border: 2px solid #2196f3; box-shadow: 0 6px 20px rgba(33, 150, 243, 0.15);">
        <h3 style="color: #0d47a1; margin-bottom: 20px;">🎯 CONCLUSION : La Rigueur, Gage de Conformité</h3>
        
        <p>Le calcul du salaire net est un processus méthodique qui exige une <strong>parfaite maîtrise des règles fiscales</strong>, notamment en ce qui concerne l'évaluation des avantages en nature. Une erreur peut entraîner des <strong>redressements fiscaux et des pénalités</strong> pour l'entreprise.</p>
        
        <div class="benefits-box p-4 mt-4" style="background-color: rgba(255, 255, 255, 0.8); border-radius: 12px;">
          <h5 style="color: #0d47a1; margin-bottom: 15px;">🤝 Pourquoi faire appel à un Expert-Comptable ?</h5>
          <div class="row">
            <div class="col-md-6 mb-3">
              <div class="benefit-item p-3" style="background-color: #d4edda; border-radius: 8px; border-left: 4px solid #28a745;">
                <p class="mb-0"><strong>✅ Garantir la conformité</strong> de vos fiches de paie</p>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <div class="benefit-item p-3" style="background-color: #d1ecf1; border-radius: 8px; border-left: 4px solid #17a2b8;">
                <p class="mb-0"><strong>✅ Optimiser</strong> la gestion de votre masse salariale</p>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <div class="benefit-item p-3" style="background-color: #fff3cd; border-radius: 8px; border-left: 4px solid #ffc107;">
                <p class="mb-0"><strong>✅ Assurer la sérénité</strong> de vos relations avec vos salariés</p>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <div class="benefit-item p-3" style="background-color: #f8d7da; border-radius: 8px; border-left: 4px solid #dc3545;">
                <p class="mb-0"><strong>✅ Sécuriser</strong> vos relations avec l'administration</p>
              </div>
            </div>
          </div>
        </div>
        
        <div class="cta-box p-4 mt-4" style="background: linear-gradient(135deg, #dc3545 0%, #198754 100%); border-radius: 12px; text-align: center; color: white;">
          <h5 style="color: white; margin-bottom: 15px;">💼 Besoin d'accompagnement ?</h5>
          <p class="mb-3" style="color: white;">L'expert-comptable est votre meilleur allié pour sécuriser votre gestion sociale et fiscale.</p>
          <p class="mb-0" style="font-weight: 600; font-size: 1.1rem;">Contactez-nous pour un diagnostic complet !</p>
        </div>
      </div>
      
      <div class="resources-section p-4 mb-4" style="background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%); border-radius: 12px; border-left: 5px solid #9c27b0;">
        <h4 style="color: #4a148c; margin-bottom: 15px;">📚 Pour aller plus loin</h4>
        <ul class="resources-list mb-0">
          <li><strong>Code Général des Impôts 2025 :</strong> Consultable sur le site de la DGI</li>
          <li><strong>Site de la Direction Générale des Impôts du Bénin :</strong> <a href="https://www.impots.bj/" target="_blank" rel="noopener">www.impots.bj</a></li>
          <li><strong>Site de l'Ordre des Experts-comptables :</strong> <a href="https://oeccabenin.bj/" target="_blank" rel="noopener">oeccabenin.bj</a></li>
        </ul>
      </div>
      
      <div class="hashtags-section p-3 text-center" style="background-color: #f8f9fa; border-radius: 8px;">
        <p class="mb-0" style="color: #6c757d; font-size: 0.9rem;">
          <strong>#CINEF #ExpertComptable #OECCA #Paie #Avantages #Impôts #Rémunération #ITS #Primes #Bonus #Indemnités #Conformité #GestionSociale #Fiscalité #Taxe #ConformitéFiscale #ConseilFiscal #DroitFiscal #Entrepreneurs #PME #Dirigeant #Comptabilité</strong>
        </p>
      </div>
    `,
    image: "/assets/images/image30.png",
    categories: ["Paie", "Fiscalité", "Gestion Sociale"],
    tags: [
      "Salaire",
      "ITS",
      "Avantages en nature",
      "Paie",
      "Fiscalité",
      "CGI",
      "VPS",
      "Bénin",
    ],
    date: "10 Octobre 2025",
    author: "Wilfrid DEDJI",
    authorTitle: "Expert-Comptable spécialisé en Gestion Sociale et Paie",
    readTime: "10 min",
    featured: true,
  };

  return (
    <>
      <Header />

      <div className="blog-content py-5">
        <div className="container">
          <nav className="breadcrumb-container mb-4">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/" className="text-decoration-none">
                  Accueil
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/actualites/blog" className="text-decoration-none">
                  Blog
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {blogPost.title}
              </li>
            </ol>
          </nav>

          <div className="row">
            <div className="col-lg-8">
              <div className="blog-header mb-4">
                <div className="categories-badges mb-2">
                  {blogPost.categories.map((category, index) => (
                    <span key={index} className="category-badge me-2">
                      {category}
                    </span>
                  ))}
                </div>
                <h1 className="blog-title">{blogPost.title}</h1>

                <div className="blog-meta d-flex align-items-center mt-3">
                  <div className="meta-item d-flex align-items-center">
                    <FaCalendarAlt className="meta-icon" />
                    <span>{blogPost.date}</span>
                  </div>
                  <div className="meta-item d-flex align-items-center">
                    <FaUser className="meta-icon" />
                    <span>{blogPost.author}</span>
                  </div>
                  <div className="meta-item d-flex align-items-center">
                    <FaClock className="meta-icon" />
                    <span>{blogPost.readTime} de lecture</span>
                  </div>
                </div>
              </div>

              

              <div className="blog-excerpt mb-4">
                <p className="lead">{blogPost.excerpt}</p>
              </div>

              <div
                className="blog-body mb-5"
                dangerouslySetInnerHTML={{ __html: blogPost.content }}
              />

              <div className="blog-tags mb-4">
                {blogPost.tags.map((tag, index) => (
                  <Link key={index} to="#" className="blog-tag">
                    #{tag}
                  </Link>
                ))}
              </div>

              <div className="blog-share mb-5">
                <h5 className="share-title">Partager cet article</h5>
                <div className="social-buttons">
                  <a href="#" className="social-button linkedin">
                    <FaLinkedin />
                  </a>
                  <a href="#" className="social-button twitter">
                    <FaTwitter />
                  </a>
                  <a href="#" className="social-button facebook">
                    <FaFacebook />
                  </a>
                </div>
              </div>

              <div className="blog-actions mb-5">
                <Link to="/actualites/blog" className="btn btn-back">
                  <FaChevronLeft className="me-2" /> Retour au blog
                </Link>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="sidebar-widget author-widget">
                <h4 className="widget-title">À propos de l'auteur</h4>
                <div className="author-profile">
                  <div className="author-image">
                    <img
                      src="/assets/images/image5.png"
                      alt={blogPost.author}
                      className="img-fluid rounded-circle"
                    />
                  </div>
                  <div className="author-info">
                    <h5 className="author-name">{blogPost.author}</h5>
                    <p className="author-title">{blogPost.authorTitle}</p>
                    <p className="author-bio">
                      Expert-comptable diplômé avec plus de 15 ans d'expérience dans la gestion sociale et la paie. Spécialiste de la réglementation fiscale béninoise et de l'optimisation des charges sociales. Formateur reconnu auprès de l'OECCA.
                    </p>
                  </div>
                </div>
              </div>

              <div className="sidebar-widget newsletter-widget">
                <h4 className="widget-title">Newsletter</h4>
                <p className="newsletter-desc">
                  Recevez nos conseils en gestion sociale et les dernières actualités fiscales
                </p>
                <form className="newsletter-form">
                  <div className="form-group mb-3">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Votre adresse email"
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary w-100">
                    S'abonner
                  </button>
                </form>
              </div>

              <div className="sidebar-widget categories-widget">
                <h4 className="widget-title">Ressources Paie & Social</h4>
                <ul className="categories-list">
                  <li>
                    <a
                      href="https://www.impots.bj"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Direction Générale des Impôts <span>→</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://oeccabenin.bj/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Ordre des Experts-Comptables <span>→</span>
                    </a>
                  </li>
                  <li>
                    <Link to="/services/audit-conseil">
                      Conseil en Gestion Sociale <span>→</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/actualites/blog">
                      Autres articles <span>→</span>
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="sidebar-widget" style={{ background: "linear-gradient(135deg, #dc3545 0%, #198754 100%)", color: "white", borderRadius: "12px" }}>
                <h4 className="widget-title" style={{ color: "white", borderBottom: "2px solid rgba(255,255,255,0.3)" }}>
                  Besoin d'aide ?
                </h4>
                <p style={{ fontSize: "14px", marginBottom: "15px" }}>
                  Nos experts en gestion sociale sont à votre disposition pour optimiser votre paie et assurer votre conformité.
                </p>
                <Link 
                  to="/contact" 
                  className="btn w-100"
                  style={{ 
                    backgroundColor: "white", 
                    color: "#dc3545",
                    fontWeight: "600",
                    borderRadius: "25px",
                    padding: "12px"
                  }}
                >
                  Contactez-nous
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <style jsx>{`
        .blog-content {
          background-color: #f8f9fa;
        }

        .breadcrumb {
          background-color: transparent;
          padding: 0;
          margin-bottom: 0;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          color: #6c757d;
        }

        .breadcrumb-item a {
          color: #6c757d;
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .breadcrumb-item a:hover {
          color: #dc3545;
        }

        .breadcrumb-item.active {
          color: #212529;
          font-weight: 500;
        }

        .blog-header {
          margin-bottom: 2rem;
        }

        .blog-title {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 1rem;
          line-height: 1.2;
          color: #212529;
        }

        .category-badge {
          display: inline-block;
          background: linear-gradient(to right, #dc3545, #198754);
          color: white;
          padding: 6px 15px;
          border-radius: 30px;
          font-size: 14px;
          font-weight: 600;
        }

        .blog-meta {
          color: #6c757d;
          font-size: 14px;
          gap: 20px;
          flex-wrap: wrap;
        }

        .meta-item {
          gap: 5px;
        }

        .meta-icon {
          font-size: 14px;
          margin-right: 5px;
          color: #dc3545;
        }

        .blog-featured-image img {
          border-radius: 10px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        .blog-excerpt .lead {
          font-size: 1.25rem;
          font-weight: 300;
          line-height: 1.6;
          color: #495057;
          border-left: 4px solid #dc3545;
          padding-left: 20px;
          background-color: #fff;
          padding: 20px;
          border-radius: 8px;
        }

        .blog-body {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #212529;
        }

        .blog-body h2 {
          margin-top: 2.5rem;
          margin-bottom: 1.5rem;
          font-weight: 700;
          color: #212529;
        }

        .blog-body h3 {
          margin-top: 2rem;
          margin-bottom: 1rem;
          font-weight: 700;
          color: #212529;
        }

        .blog-body h4 {
          margin-top: 1.5rem;
          margin-bottom: 0.8rem;
          font-weight: 600;
          color: #343a40;
        }

        .blog-body h5 {
          margin-top: 1.2rem;
          margin-bottom: 0.6rem;
          font-weight: 600;
        }

        .blog-body p {
          margin-bottom: 1.5rem;
        }

        .blog-body ul,
        .blog-body ol {
          margin-bottom: 1.5rem;
          padding-left: 1.5rem;
        }

        .blog-body li {
          margin-bottom: 0.8rem;
        }

        .blog-body a {
          color: #dc3545;
          text-decoration: none;
          font-weight: 500;
        }

        .blog-body a:hover {
          text-decoration: underline;
        }

        .blog-body code {
          background-color: #f8f9fa;
          color: #e83e8c;
          padding: 2px 6px;
          border-radius: 4px;
          font-size: 0.9em;
          font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
        }

        .blog-body strong {
          font-weight: 600;
          color: #212529;
        }

        .blog-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 2rem;
          padding-top: 2rem;
          border-top: 1px solid #dee2e6;
        }

        .blog-tag {
          display: inline-block;
          background-color: #e9ecef;
          color: #495057;
          padding: 5px 12px;
          border-radius: 20px;
          text-decoration: none;
          font-size: 13px;
          transition: all 0.3s ease;
        }

        .blog-tag:hover {
          background-color: #dc3545;
          color: white;
          transform: translateY(-2px);
        }

        .blog-share {
          margin-top: 2rem;
          padding-top: 1.5rem;
          border-top: 1px solid #dee2e6;
        }

        .share-title {
          font-size: 1rem;
          margin-bottom: 1rem;
          color: #495057;
          font-weight: 600;
        }

        .social-buttons {
          display: flex;
          gap: 15px;
        }

        .social-button {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-decoration: none;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          font-size: 18px;
        }

        .social-button:hover {
          transform: translateY(-3px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }

        .linkedin {
          background-color: #0077b5;
        }

        .twitter {
          background-color: #1da1f2;
        }

        .facebook {
          background-color: #4267b2;
        }

        .btn-back {
          display: inline-flex;
          align-items: center;
          background-color: white;
          color: #495057;
          padding: 12px 24px;
          border-radius: 30px;
          text-decoration: none;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
          font-weight: 500;
        }

        .btn-back:hover {
          background-color: #dc3545;
          color: white;
          transform: translateX(-5px);
          box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
        }

        .sidebar-widget {
          background-color: white;
          border-radius: 12px;
          padding: 25px;
          margin-bottom: 30px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
        }

        .widget-title {
          font-size: 1.25rem;
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 2px solid #f0f0f0;
          position: relative;
          font-weight: 700;
        }

        .widget-title:after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 60px;
          height: 2px;
          background: linear-gradient(to right, #dc3545, #198754);
        }

        .author-profile {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }

        .author-image {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          overflow: hidden;
          margin-bottom: 15px;
          border: 3px solid #dc3545;
        }

        .author-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .author-name {
          font-size: 18px;
          margin-bottom: 5px;
          font-weight: 700;
        }

        .author-title {
          font-size: 14px;
          color: #dc3545;
          margin-bottom: 10px;
          font-weight: 500;
        }

        .author-bio {
          font-size: 14px;
          color: #6c757d;
          margin-bottom: 0;
          line-height: 1.6;
        }

        .newsletter-desc {
          margin-bottom: 15px;
          color: #6c757d;
          font-size: 14px;
        }

        .btn-primary {
          background: linear-gradient(45deg, #dc3545, #198754);
          border: none;
          border-radius: 30px;
          padding: 12px 25px;
          font-weight: 600;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(220, 53, 69, 0.3);
        }

        .btn-primary::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(45deg, rgba(255, 255, 255, 0.2), transparent);
          transition: left 0.5s ease;
        }

        .btn-primary:hover::before {
          left: 100%;
        }

        .newsletter-form .form-control {
          border-radius: 25px;
          border: 2px solid #e9ecef;
          padding: 12px 20px;
          transition: all 0.3s ease;
        }

        .newsletter-form .form-control:focus {
          border-color: #dc3545;
          box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
        }

        .categories-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .categories-list li {
          margin-bottom: 12px;
        }

        .categories-list a {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 15px;
          background-color: #f8f9fa;
          color: #495057;
          text-decoration: none;
          border-radius: 8px;
          transition: all 0.3s ease;
          font-weight: 500;
        }

        .categories-list a:hover {
          background-color: #dc3545;
          color: white;
          transform: translateX(5px);
        }

        .categories-list a span {
          font-weight: bold;
          transition: transform 0.3s ease;
        }

        .categories-list a:hover span {
          transform: translateX(5px);
        }

        @media (max-width: 768px) {
          .blog-title {
            font-size: 2rem;
          }

          .blog-meta {
            flex-direction: column;
            gap: 10px;
            align-items: flex-start;
          }

          .meta-item {
            width: 100%;
          }

          .blog-body {
            font-size: 1rem;
          }

          .social-buttons {
            justify-content: center;
          }

          .author-profile {
            flex-direction: row;
            text-align: left;
            gap: 15px;
          }

          .author-image {
            width: 80px;
            height: 80px;
          }
          .author-name {
            font-size: 16px;
          }
          .author-title {
            font-size: 13px;
          }
          .author-bio {
            font-size: 13px;
          }
        }
      `}</style>
    </>
  );
};
export default DetailBlog6;